import { getMembershipTiers } from "actions/membership-tier-actions";
import { userCanRejoinWithPriorTier } from "helpers/membership-tier-helpers";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

export const useSubscriptionRejoinUrl = () => {
  const dispatch = useDispatch();
  const membershipTiers = useSelector(s => s.membershipTiers);
  const membershipTiersLoading = useSelector(s => s.membershipTiersLoading);
  const membershipState = useSelector(s => s.membershipState);

  useEffect(function fetchTiers() {
    if (!Array.isArray(membershipTiers) && !membershipTiersLoading) {
      dispatch(getMembershipTiers());
    }
  }, []);

  const userCanRejoin = userCanRejoinWithPriorTier(membershipState, membershipTiers);
  const rejoinUrl = `/ce-checkout/membershipTierId/${membershipState?.membershipTierId}`;

  return { userCanRejoin, rejoinUrl };
};
